/**
 * 数据报警 store
 */

import axios from "../../utils/axios";

let state = {
  showData: [],
  policeMessage: []
};

let getters = {
  showData(state) {
    return state.showData;
  },
  nowData(state) {
    return state.nowData;
  }
};

let mutations = {
  setPoliceMessage(state, payload) {
    state.policeMessage = payload.policeMessage;
  },
  setShowData(state, payload) {
    state.showData = payload.showData;
  },
  setPoliceNowMessage(state, payload) {
    state.policeNowMessage = payload.policeNowMessage;
  },
  setNowData(state, payload) {
    state.nowData = payload.nowData;
  }
};

let actions = {
  policeMessage({ rootState }) {
    return new Promise((resolve, reject) => {
      axios.get(`/meteorological?farm_id=${rootState.farmId}`)
      .then(res => {
        if (res.status === 200) {
          resolve(res.data.data);
        }
      })
      .catch(error => {
        console.error(error);
        reject();
      });
    });
  },
  policeNowMessage({ rootState }) {
    return axios.get(`/meteorological_now?farm_id=${rootState.farmId}`);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}
